// CANONICAL COPY (GH #7115). src/constants/obligations/obl-subprocessor-approval.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-subprocessor-approval',
  title: 'Verify sub-processor approval and flow-down data-protection obligations',
  description:
    'Confirm that sub-processors are engaged only with specific or general controller approval, and that sub-processor agreements impose the same data-protection obligations as the DPA (GDPR Art. 28(2), Art. 28(4); FSR ISAE 3000 Kontrolmål F.2, F.4). Evidence shall include signed controller approvals per sub-processor (or documented reliance on general authorisation), and executed sub-processor agreements that contain flow-down clauses covering instructions, confidentiality, security measures, assistance, deletion and audit rights. Review the sub-processor approval register, sample executed sub-processor agreements and verify flow-down clauses are present.',
  category: 'vendors',
  scfIds: ['SCF-VDR-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  // GH #6698, founder decision B. Was `strategy: 'any'`, under which a
  // published, in-SLA procedure fulfilled this obligation ON ITS OWN — and a
  // fulfilled obligation then rendered every other criterion as "Fulfilled",
  // so a tenant with an unclassified vendor register was shown a green tick
  // against signed controller approvals and executed flow-down agreements.
  //
  // `manual` requires ALL criteria plus the human attestation, and yields
  // `partially-satisfied` rather than `unmet` for a tenant that has the
  // procedure but not the record — so nobody is stranded, and nobody is told
  // the record exists. This is the product's own doctrine applied where it
  // already belonged: "a published/current document is machine-checkable
  // evidence that a policy or procedure exists; it is never treated as proof
  // the underlying activity actually occurred" (`evaluateManualObligation`).
  // GDPR Art. 28(2) requires a register, not a procedure describing one.
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'subprocessor-dpa-signed',
      description: 'Every processor vendor has a signed, in-date DPA',
    },
    { type: 'document-published', description: 'Sub-processor approval standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
    {
      type: 'manual-attestation',
      description:
        'Confirm controller approvals are held for every sub-processor (or documented reliance on general authorisation), and that executed sub-processor agreements carry the flow-down clauses',
    },
  ],
  domainActions: [
    { type: 'deep-link', target: 'vendors', label: 'Review Vendors' },
    { type: 'approve-document', label: 'Approve Document' },
  ],
};
